import {Component} from '@angular/core'
import {ListComponent} from 'src/app/shared/ui/list/list.component'
import {FiltersComponent} from 'src/app/shared/ui/filters/filters.component'

@Component({
    selector: 'app-add-collaborateur',
    templateUrl: './add-collaborateur.component.html',
    styleUrls: ['./add-collaborateur.component.scss'],
    imports: [FiltersComponent, ListComponent]
})
export class AddCollaborateurComponent {
    constructor() {}

}
